// Central content source. Architected so new products can be added to `products`
// without touching layout code — Nova remains the flagship (isFlagship: true).

export const NAV_LINKS = [
  { label: "Home", href: "/#home" },
  { label: "Services", href: "/#services" },
  { label: "About", href: "/#about" },
  { label: "Contact", href: "/#contact" },
];

export const CONTACT_EMAIL = "hello@theinceptica.com";
export const NOVA_URL = "https://www.teamnova.ai";
export const LINKEDIN_URL = "https://www.linkedin.com/company/inceptica";

export const COMPLIANCE_FRAMEWORKS = [
  "SOC 2",
  "ISO 27001",
  "PCI DSS",
  "GDPR",
  "HIPAA",
  "AI & Privacy",
];

// Flagship + future products live here.
export const PRODUCTS = [
  {
    id: "nova",
    name: "Nova",
    isFlagship: true,
    tagline: "AI-Powered Compliance and Certification Platform",
    description:
      "Nova helps organisations simplify compliance and certification through intelligent automation — finding gaps, collecting evidence automatically and coordinating independent audits across SOC 2, ISO 27001, PCI DSS, GDPR, HIPAA and AI & Privacy regulations.",
    url: NOVA_URL,
    accent: "#2563EB",
  },
];

export const SERVICES = [
  {
    id: "ai-consulting",
    title: "AI Consulting",
    description:
      "Helping organisations identify and implement practical AI solutions that create measurable value.",
    icon: "Compass",
  },
  {
    id: "ai-product-engineering",
    title: "AI Product Engineering",
    description:
      "Designing and building enterprise AI products and SaaS platforms customers rely on every day.",
    icon: "Boxes",
  },
  {
    id: "enterprise-software",
    title: "Enterprise Software Development",
    description:
      "Modern cloud applications that power digital transformation across the organisation.",
    icon: "Layers",
  },
  {
    id: "systems-integration",
    title: "Systems Integration",
    description:
      "Connecting enterprise applications and business workflows into one coherent experience.",
    icon: "Workflow",
  },
];

export const VALUES = [
  {
    id: "product-first",
    title: "Product-first mindset",
    description:
      "We build products, not projects — obsessing over experience, reliability and long-term value.",
    icon: "Sparkles",
  },
  {
    id: "enterprise-grade",
    title: "Enterprise-grade engineering",
    description:
      "Security, scale and quality are engineered in from day one, not bolted on later.",
    icon: "ShieldCheck",
  },
  {
    id: "customer-centric",
    title: "Customer-centric innovation",
    description:
      "Every decision starts with the outcomes our customers are trying to achieve.",
    icon: "HeartHandshake",
  },
  {
    id: "partnerships",
    title: "Long-term partnerships",
    description:
      "We invest in relationships that compound — growing alongside the organisations we serve.",
    icon: "Infinity",
  },
];

export const LEADERSHIP = [
  {
    id: "swarna",
    name: "Swarna Duttaluri",
    monogram: "SD",
    role: "Founder",
    bio: "Leads strategy, customer success and business growth.",
  },
  {
    id: "srineha",
    name: "Srineha Korugundla",
    monogram: "SK",
    role: "Business Strategy & Product Operations",
    bio: "Drives product strategy, delivery and customer value.",
  },
  {
    id: "sri",
    name: "Sri Arardhi",
    monogram: "SA",
    role: "Strategic Mentor",
    bio: "Guides product vision, platforms and business growth.",
  },
];
